import type { BoxProps } from "@mui/material";
import type React from "react";
import { createContext, useContext, useMemo } from "react";

export interface IGridListVirtualizedContext {
  List?: BoxProps;
  ListItem?: BoxProps;
}

interface IGridLListVirtualizedContextProps extends IGridListVirtualizedContext {
  children: React.ReactNode;
}

const context = createContext<IGridListVirtualizedContext>({});

export const useLGridistVirtualizedContext = () => useContext(context);

export const ListVirtualizedProvider = ({ children, ...props }: IGridLListVirtualizedContextProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => ({ ...props }), [props.List, props.ListItem]);

  return <context.Provider value={value}>{children}</context.Provider>;
};
